import React from "react";
import DoctorLayout from "../../components/Layout/DoctorLayout-new";
import LayoutWithbg from "../../components/LayoutWithbg";

/** Wraps OT pages with the app navbar + page background, keeping OT sidebar inside. */
export default function OTAppShell({ setSearchText, children }) {
  return (
    <DoctorLayout setSearchText={setSearchText}>
      <LayoutWithbg>{children}</LayoutWithbg>
    </DoctorLayout>
  );
}
